import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, markRaw, ref, toRefs } from 'vue'

import { useModalOpener } from '@/composables/useModalOpener'
import useGlobal from '@/composables/useGlobal'

import { twoFactorRequestResource } from '@services/auth.service'

import { useModalSlot } from 'vue-final-modal'

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationCheck',
  props: {
    token: {},
    action: { type: Function },
    additionalData: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const ModalWrapper = defineAsyncComponent(
  () => import('@/components/ui/modals/ModalWrapper.vue')
)
const TokenConfirmation = defineAsyncComponent(
  () => import('@app/token/Confirmation.vue')
)

const props = __props

const { token, action, additionalData } = toRefs(props)

const is_confirmed = ref(false)
const code = ref('')
const captcha = ref('')
const isLoad = ref('')
const captchaRef = ref('')
const reopenModal = ref(true)

const { $t } = useGlobal()

const sendCode = async () => {
  try {
    const { id } = await twoFactorRequestResource.execute(
      {},
      {
        token: token.value,
        captcha: captcha.value,
      }
    )
    patchOptionsConfirmModal({
      slots: {
        default: useModalSlot({
          component: markRaw(ModalWrapper),
          attrs: {
            id,
            captcha: captcha.value,
          },
        }),
      },
    })
    if (reopenModal.value) {
      openConfirmModal()
    }
    captchaRef.value.reset()
  } catch (e) {
    captchaRef.value.reset()
    const clientError = 400
    const serverError = 500
    if (
      !e.data ||
      !e.data.code ||
      clientError > e.data.code ||
      serverError <= e.data.code
    ) {
      throw e
    }
    e.json().then((body) => {
      const errors: {
        token?: [{ message: string }]
      } = {}
      body.errors.forEach((error) => {
        if ('request' === error.domain && error.state) {
          Object.assign(errors, error.state)
        }
      })
      const [{ message }] = errors?.token || [{ message: $t('Error') }]
      useModalOpener({
        name: 'UiMessageModal',
        component: 'UiMessageModal',
        meta: {
          title: $t('Token validation error header'),
          text: message,
          // location: redirect.location
        },
        classes: 'modal--size_xs',
      })
    })
  }
}

const validate = (openModal = true) => {
  reopenModal.value = openModal
  isLoad.value = true
  captchaRef.value.execute()
}

const {
  open: openConfirmModal,
  options,
  patchOptions: patchOptionsConfirmModal,
} = useModalOpener(
  {
    name: 'TokenConfirmation',
    component: TokenConfirmation,
    token: token.value,
    action: action.value,
    additionalData: additionalData.value,
    captcha: captcha.value,
    validate: validate,
    clickToClose: false,
  },
  {
    clickToClose: false,
  }
)
const openModal = (id) => {
  isLoad.value = false
  patchOptionsConfirmModal({
    slots: {
      default: useModalSlot({
        component: markRaw(ModalWrapper),
        attrs: {
          token: token.value,
          id,
          action: action.value,
          additionalData: additionalData.value,
          captcha: captcha.value,
          validate: validate,
        },
      }),
    },
  })
  openConfirmModal()
}

const saveCaptcha = (val) => {
  captcha.value = val
  if (val) {
    sendCode()
  }
}

const __returned__ = { ModalWrapper, TokenConfirmation, props, token, action, additionalData, is_confirmed, code, captcha, isLoad, captchaRef, reopenModal, $t, sendCode, validate, openConfirmModal, options, patchOptionsConfirmModal, openModal, saveCaptcha, defineAsyncComponent, markRaw, ref, toRefs, get useModalOpener() { return useModalOpener }, get useGlobal() { return useGlobal }, get twoFactorRequestResource() { return twoFactorRequestResource }, get useModalSlot() { return useModalSlot } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})